<template>
  <main class='About' v-if='kirby.page.intendedTemplate=="about"'>
    <h6 v-html='kirby.page.content.title.value' />
    <h1 v-html='kirby.page.content.subtitle.value' />

    <section v-for="section in JSON.parse(kirby.page.strings.content)"  :key="section.id">
      <videoblock v-if='section.type=="video"' :block='section' />
      <!-- Description -->
      <article v-if='section.type == "description"' class='body'>
        <section class='english' v-html='section.content.english' />
        <section class='finnish' v-html='section.content.finnish' />
      </article>
      <!-- List -->
      <section v-if='section.type == "list"' class='list'>
        <h5 class='title' v-html='section.content.title' />
        <dl v-for='listitem in section.content.list'>
          <dt v-html='listitem.title' />
          <dd v-html='listitem.content' />
        </dl>
      </section>
    </section>

    <!--{{kirby.page.strings.content}}-->

    <!--<article class='body'>
      <section class='english' v-html='kirby.page.content.english.kirbytext' />
      <section class='finnish' v-html='kirby.page.content.finnish.kirbytext' />
    </article>-->

    <MainFooter />

  </main>
</template>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>

<style scoped>

  h1 {
    max-width: 10em;
    line-height: 1em;
  }

  h6 {
    margin-bottom: 0.5em;
  }

  article.body {
    margin-top: 12em;
    display: flex;
    flex-direction: var(--columndirection);
    gap: 3em;
  }

  article section {
    max-width: 30em;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  section.list {
    color: var(--midgray);
    margin-top: 8em;
    display: flex;
    flex-wrap: wrap;
  }

  section.list h4.title {
    width: 100%;
    margin-bottom: 2em;
  }

  dl {
    display: inline-block;
    width: 100%;
    padding: 0;
    margin: 0;
    margin-bottom: 3em;
    max-width: 24em;
  }

  dt {
    text-transform: uppercase;
    padding: 0;
    margin: 0;
    margin-bottom: 0em;
  }

  dd {
    padding-left: 1.5em;
    margin: 0;
    text-indent: -1.5em;
    padding-right: 2em;
  }

</style>

<style>
  main.About p {
    margin: 0;
    margin-bottom: 1.2em;
  }
</style>
